/**
 * Route prefetch map — maps route paths to their dynamic import functions.
 * Used by sidebar to preload chunks on hover/focus for instant navigation.
 */

const routeImports: Record<string, () => Promise<unknown>> = {
  '/dashboard': () => import('@/pages/dashboard/DashboardPage'),
  '/subscribers': () => import('@/pages/subscribers/SubscriberListPage'),
  '/billing': () => import('@/pages/billing/BillingPage'),
  '/plans': () => import('@/pages/plans/PlansPage'),
  '/tickets': () => import('@/pages/tickets/TicketsPage'),
  '/noc': () => import('@/pages/noc/NocPage'),
  '/olt': () => import('@/pages/olt/OltPage'),
  '/nas': () => import('@/pages/nas/NasPage'),
  '/inventory': () => import('@/features/inventory/pages/InventoryDashboardPage'),
  '/inventory/reports': () => import('@/features/inventory/pages/ReportsPage'),
  '/ipam': () => import('@/pages/ipam/IpamPage'),
  '/notifications': () => import('@/pages/notifications/NotificationsPage'),
  '/reports': () => import('@/pages/reports/ReportsPage'),
  '/settings': () => import('@/pages/settings/SettingsPage'),
  '/jobs': () => import('@/pages/jobs/JobsDashboardPage'),
  '/logs': () => import('@/pages/logs/LogsPage'),
};

const prefetched = new Set<string>();

/**
 * Prefetch a route's code chunk. Idempotent — only loads once per route per session.
 */
export function prefetchRoute(href: string): void {
  // Normalize: /settings/users → /settings
  const base = '/' + href.split('/').filter(Boolean)[0];
  if (prefetched.has(base)) return;

  const loader = routeImports[base];
  if (loader) {
    prefetched.add(base);
    // Fire-and-forget — errors are silently ignored
    loader().catch(() => {
      prefetched.delete(base);
    });
  }
}
